// extracted by mini-css-extract-plugin
export default {"ListContentWrapper":"Ksvsh2IP"};